import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const menuContainer = document.body;

class ModalPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    menuContainer.appendChild(this.el);
    document.addEventListener('click', this.closeModal);
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    menuContainer.removeChild(this.el);
    document.removeEventListener('click', this.closeModal);
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    if (this.props.onResize) this.props.onResize();
  };

  closeModal = (evt) => {
    if (this.el && this.el.contains(evt.target)) return;
    if (this.props.onClose) this.props.onClose();
  };

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

class ContextMenu extends Component {
  state = {
    active: false,
    x: 0,
    y: 0,
    actions: null,
  };

  initialScrollX = 0;
  initialContainerScrollLeft = 0;
  scrollContainer = null;

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { capture: true });
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, { capture: true });
    window.removeEventListener('resize', this.handleResize);
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = () => {
    if (!this.state.active) return;

    let currentScrollX = window.scrollX || document.documentElement.scrollLeft || 0;
    let currentContainerScrollLeft = this.scrollContainer ? this.scrollContainer.scrollLeft : 0;

    if (currentScrollX !== this.initialScrollX || currentContainerScrollLeft !== this.initialContainerScrollLeft) this.onClose();
  };

  handleResize = () => {
    if (!this.state.active) return;
    const { x, y } = this.state;
    const menuWidth = 250;
    const menuHeight = 150;

    if (x + menuWidth > window.innerWidth || y + menuHeight > window.innerHeight) this.onClose();
  };

  open = (event, actions, scrollContainer = null) => {
    event.preventDefault();
    const { pageX, pageY } = event;
    let x = pageX + 5;
    let y = pageY + 5;
    const menuWidth = 250;
    const menuHeight = 150;

    if (x + menuWidth > window.innerWidth) x = window.innerWidth - menuWidth - 5;
    if (y + menuHeight > window.innerHeight) y = window.innerHeight - menuHeight - 5;

    this.initialScrollX = window.scrollX || document.documentElement.scrollLeft || 0;
    this.scrollContainer = scrollContainer || null;
    this.initialContainerScrollLeft = this.scrollContainer ? this.scrollContainer.scrollLeft : 0;

    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      this.scrollContainer.addEventListener('scroll', this.handleScroll);
    }

    this.setState({ active: true, x, y, actions });
  };

  onClose = () => {
    this.setState({ active: false, actions: null });
    
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      this.scrollContainer = null;
    }
  };

  onAction = (action) => (e) => {
    e.preventDefault();
    action();
    this.onClose();
  };

  render() {
    const { active, x, y, actions } = this.state;
    if (!active || !actions || actions.length === 0) return null;

    return (
      <ModalPortal onClose={this.onClose} onResize={this.handleResize}>
        <div
          className="dropdown-menu dropdown-menu-right"
          style={{
            position: 'absolute',
            top: y,
            left: x,
            display: 'block',
            width: '250px',
            zIndex: 9999,
          }}
        >
          <ul className="kt-nav" style={{ padding: 0 }}>
            {actions.map((item, index) => (
              <li key={index} className="kt-nav__item">
                <a onClick={this.onAction(item.action)} className="kt-nav__link" style={item.style || {}} href="/">
                  <i
                    className={`kt-nav__link-icon ${item.icon}`}
                    style={(item.style && item.style.color) ? { color: item.style.color } : {}}
                  />
                  <span className="kt-nav__link-text">{item.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </ModalPortal>
    );
  }
}

export default ContextMenu;